import { defineStore } from 'pinia'
import { Directory } from '~/static/types/directories'

interface DirectoriesStore {
  directories: Directory[]
}

export const useDirectoriesStore = defineStore('directories', {
  state: (): DirectoriesStore => {
    return {
      directories: [],
    }
  },
  actions: {
    async loadData(): Promise<void> {
      interface LoadDirectoriesResponse {
        directories: Directory[]
      }

      const { response, error } = await useApi<LoadDirectoriesResponse>('directories.getList')
      if (error) {
        // eslint-disable-next-line no-console
        console.log(error.error_code, error.error_msg)
      } else if (response) {
        this.directories = response.directories
      }
    },
    async create(name: string): Promise<number> {
      const { response, error } = await useApi<{ id: number }>('directories.create', {}, HttpMethod.POST, { name })
      if (error) {
        // eslint-disable-next-line no-console
        console.log(error.error_code, error.error_msg)
      } else if (response) {
        this.directories.unshift({ id: response.id, name })
        track('Folder created', {
          Created: this.directories.length < 10 ?
            'less than 9' :
            this.directories.length >= 20 ?
              'more than 20' :
              '10-19',
        })
        return Promise.resolve(response.id)
      }
      return Promise.reject(error ?? 'No response')
    },
    async changeName(id: number, name: string): Promise<void> {
      const { response, error } = await useApi<boolean>('directories.changeName', {}, HttpMethod.POST, {
        directory_id: id,
        name: name,
      })
      if (error) {
        // eslint-disable-next-line no-console
        console.log(error.error_code, error.error_msg)
      } else if (response) {
        const index = this.directories.findIndex((dir) => {
          return dir.id === id
        })
        if (index >= 0) {
          this.directories[index].name = name
        }
        return Promise.resolve()
      }
      return Promise.reject(error ?? 'No response')
    },
    async delete(id: number): Promise<void> {
      const { response, error } = await useApi<boolean>('directories.delete', {}, HttpMethod.POST, {
        directory_id: id,
      })
      if (error) {
        // eslint-disable-next-line no-console
        console.log(error.error_code, error.error_msg)
      } else if (response) {
        const index = this.directories.findIndex((dir) => {
          return dir.id === id
        })
        if (index >= 0) {
          this.directories.splice(index, 1)
        }
        return Promise.resolve()
      }
      return Promise.reject(error ?? 'No response')
    },
    async putCard(cardId: number, directoryId: number | null): Promise<void> {
      const { response, error } = await useApi<boolean>('directories.putCard', {}, HttpMethod.POST, {
        directory_id: directoryId,
        card_id: cardId,
      })
      if (error) {
        // eslint-disable-next-line no-console
        console.log(error.error_code, error.error_msg)
      } else if (response) {
        return Promise.resolve()
      }
      return Promise.reject(error ?? 'No response')
    },
  },
})
